import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllCountry = lazy(() => import("../pages/all-country"));

export const CountryRouter = [
  {
    path: "/master-management/country",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllCountry />
          </Suspense>
        ),
      },
    ],
  },
];
